// extracted by mini-css-extract-plugin
module.exports = {"root":"Register_root__2C-FL","header":"Register_header__GkBt9","hint":"Register_hint__3M-4L"};